import { useMemo } from 'react';
import { useAuth, isPresenter } from '../../contexts/AuthContext';
import { filterTutorialSessions } from '../../config/featureAccess';
import { TUTORIAL_SESSIONS } from './tutorialSessions';

export function useVisibleTutorialSessions() {
  const { isAuthenticated, currentUser } = useAuth();

  return useMemo(() => {
    const ctx = {
      isAuthenticated,
      isPresenter: isPresenter(currentUser)
    };
    return filterTutorialSessions(TUTORIAL_SESSIONS, ctx);
  }, [isAuthenticated, currentUser]);
}
